import axios from 'axios';

import { Collaborator } from '../interfaces/Collaborator';

export const assignResponsible = async (carId: string, userId: string, forceCloseActiveSessions?: boolean) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BACKEND_URL}/cars/${carId}/assign-responsible`,
    { userId, ...(forceCloseActiveSessions !== undefined && { forceCloseActiveSessions }) },
    { withCredentials: true }
  );
  return response.data;
};

/**
 * Remove colaborador(es) do veículo (at-45). Com `collaboratorId`, remove apenas ele —
 * as sessões ativas dos demais vinculados não são afetadas. Sem `collaboratorId`,
 * remove todos ("Não atribuir", o padrão dos modais desde a at-93).
 */
export const unassignResponsible = async (
  carId: string,
  forceCloseActiveSessions?: boolean,
  collaboratorId?: string,
) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BACKEND_URL}/cars/${carId}/unassign-responsible`,
    {
      ...(forceCloseActiveSessions !== undefined && { forceCloseActiveSessions }),
      ...(collaboratorId !== undefined && { collaboratorId }),
    },
    { withCredentials: true }
  );
  return response.data;
};

export const fetchCollaborators = async (
  page: number = 1,
  limit: number = 5
): Promise<{ users: Collaborator[], total: number }> => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/collaborators`, {
      params: { page, limit },
      withCredentials: true,
    });

    return {
      users: response.data.users as Collaborator[],
      total: response.data.total,
    };
  } catch (error: unknown) {
    console.error('Erro ao buscar colaboradores:', error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar colaboradores');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

export const fetchUsersByTypes = async (
  userTypes: string[],
  page: number = 1,
  limit: number = 50
): Promise<{ users: Collaborator[]; total: number }> => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/by-types`, {
      params: { userTypes, page, limit },
      paramsSerializer: {
        indexes: null,
      },
      withCredentials: true,
    });

    return {
      users: response.data.users as Collaborator[],
      total: response.data.total,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar usuários por perfil');
    }

    throw new Error('Erro desconhecido');
  }
};

export const searchCollaborators = async (fullName: string, page?: number, limit?: number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/users/searchCollaborator`,
      {
        params: {
          fullName,
          page: page || 1,
          limit: limit || 10,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar colaboradores');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

export const getCarsByCollaborator = async (collaboratorId: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/collaborators/${collaboratorId}/cars`,
      { withCredentials: true }
    );
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao obter carros');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

// at-46: `updateCarStatus` foi REMOVIDA (decisão do usuário, 02/08/2026) junto com a rota
// `PATCH /collaborators/:carId/status` e o modal órfão `CollaboratorCarsModal`. Era uma
// segunda via de mudança de esteira, sem as regras de /cars, e estava quebrada: enviava
// `{ newStatus }` onde o backend lia `esteiraId`. Use `updateCarStatus` de `carsApi.ts`.
